import {fromEvent} from 'rxjs';
import {map, debounceTime} from 'rxjs/operators';
import * as qs from "app/lib/helperjs";

const HEADER_SELECTOR = '.mainhead';
const AVAILABLE_AT_SELECTOR = ['.mainhead .landing-page', '.mainhead .normal-page'].join(', ');
const NOTIFICATION_BAR_SELECTOR = '.notificationBar';

const STICKY_CLASS_FOR_HEADER = 'sticky';
const STICKY_CLASS_FOR_BODY = 'menu-stuck';

export const StickyMenu = () => {
    const isProperMenu = Boolean(qs.querySelector(AVAILABLE_AT_SELECTOR));

    if (!isProperMenu) {
        return;
    }

    const header = qs.querySelector(HEADER_SELECTOR);
    const headerHeight = header.offsetHeight;
    const notificationBar = qs.querySelector(NOTIFICATION_BAR_SELECTOR);

    fromEvent(window, 'scroll')
        .pipe(
            map(() => window.scrollY),
            debounceTime(100),
        )
        .subscribe((scroll) => {
            const notificationBarHeight = notificationBar ? notificationBar.offsetHeight : 0;
            header.style.top = notificationBarHeight + 'px';

            if (scroll > (headerHeight + notificationBarHeight)) {
                qs.addClass(header, STICKY_CLASS_FOR_HEADER);
                qs.addClass(document.body, STICKY_CLASS_FOR_BODY);
            } else {
                qs.removeClass(header, STICKY_CLASS_FOR_HEADER);
                qs.removeClass(document.body, STICKY_CLASS_FOR_BODY);
            }
        });
};
